module.exports = __webpack_public_path__ + "tj.88ea306f.svg";